import { Component } from '@angular/core';

@Component({
  selector: 'app-page-banner',
  imports: [],
  templateUrl: './page-banner.component.html',
  styleUrl: './page-banner.component.css'
})
export class PageBannerComponent {

}
